module.exports = __webpack_public_path__ + "img/LOGO_BLANCO.5e557e08.svg";